class ProductContentTabsV2 extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
    if (this.tabs.length === 0 || this.panels.length === 0) return;

    this.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-tab-trigger]');
      if (tab && this.contains(tab)) this.select(tab);
    });
  }

  select(tab) {
    if (tab.getAttribute('aria-selected') === 'true') return;

    const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
    if (!panel) return;

    this.tabs.forEach((other) => {
      const active = other === tab;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.panels.forEach((item) => {
      item.hidden = item !== panel;
    });
  }
}

if (!customElements.get('product-content-tabs-v2')) {
  customElements.define('product-content-tabs-v2', ProductContentTabsV2);
}
